import WithRender from "../../templates/containers/quantitySelectionContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getQuantitySelection"]),
    getContainer: function () {
      if (this.getQuantitySelection && this.getQuantitySelection != "") {
        return "appQuantitySelection";
      } else {
        return "appQuantityField";
      }
    }
  }
});
